if (typeof ShippingNotice !== "function") {
  class ShippingNotice extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const freeShippingThreshold = Number(
        this.getAttribute("data-free-shipping")
      );
      const cartTotal = Number(this.getAttribute("data-cart-total-amount"));
      const freeShippingRemaining =
        cartTotal -
        Math.round(
          freeShippingThreshold *
            (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1)
        );
      let shippingMessage = "";
      let shippingSuccess = false;

      if (freeShippingRemaining < 0) {
        shippingMessage =
          window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace(
            "{{ remaining_amount }}",
            this._formatMoney(
              Math.abs(freeShippingRemaining),
              KROWN.settings.shop_money_format
            )
          );
      } else {
        shippingMessage =
          window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      if (this.hasAttribute("data-show-alert")) {
        this.innerHTML = `
          <div class="shipping-notice-alert alert alert--wide alert--${
            shippingSuccess ? "success" : "note"
          }">
          <div class="progress-bar-container hide-if-empty-cart">
            <div
              class="progress-bar"
              id="progress-bar"
              data-free-shipping="{{ settings.cart_free_shipping_amount | times: 100 }}"
              data-cart-total-amount="{{ cart.total_price }}"
            >
                <div class="progress-bar-inner">
                  <div class="progress-bar-icon">
                    <svg height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g style="fill:none;stroke:#202020;stroke-miterlimit:10;stroke-width:2;stroke-linejoin:round;stroke-linecap:round"><path d="m17 15h26c2.3 0 2.1 1.6 1.7 3.1s-3.7 14.9-3.7 14.9h10.1l4-2 3.9 2v8c0 1.3-.5 2-2 2h-8m-40 0h6.6m9.4 0h14.6"/><path d="m43.6 23h5.4l6.1 8m-24.1-8h-22m18 8h-22"/><path d="m24.8 44a6.9 6.9 0 0 1 -6.2 5c-2.7 0-4.2-2.2-3.4-5a6.9 6.9 0 0 1 6.2-5c2.6 0 4.2 2.2 3.4 5zm24 0a6.9 6.9 0 0 1 -6.2 5c-2.7 0-4.2-2.2-3.4-5a6.9 6.9 0 0 1 6.2-5c2.6 0 4.2 2.2 3.4 5z"/></g></svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="shipping-notice-message">${shippingMessage}</div>
          </div>`;
      } else {
        this.innerHTML = `
        <div class="progress-bar-container hide-if-empty-cart">
          <div
            class="progress-bar"
            id="progress-bar"
            data-free-shipping="{{ settings.cart_free_shipping_amount | times: 100 }}"
            data-cart-total-amount="{{ cart.total_price }}"
          >
            <div class="progress-bar-inner">
              <div class="progress-bar-icon">
                <svg height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g style="fill:none;stroke:#202020;stroke-miterlimit:10;stroke-width:2;stroke-linejoin:round;stroke-linecap:round"><path d="m17 15h26c2.3 0 2.1 1.6 1.7 3.1s-3.7 14.9-3.7 14.9h10.1l4-2 3.9 2v8c0 1.3-.5 2-2 2h-8m-40 0h6.6m9.4 0h14.6"/><path d="m43.6 23h5.4l6.1 8m-24.1-8h-22m18 8h-22"/><path d="m24.8 44a6.9 6.9 0 0 1 -6.2 5c-2.7 0-4.2-2.2-3.4-5a6.9 6.9 0 0 1 6.2-5c2.6 0 4.2 2.2 3.4 5zm24 0a6.9 6.9 0 0 1 -6.2 5c-2.7 0-4.2-2.2-3.4-5a6.9 6.9 0 0 1 6.2-5c2.6 0 4.2 2.2 3.4 5z"/></g></svg>
              </div>
            </div>
          </div>
        </div>
        <div class="shipping-notice-message">${shippingMessage}</div>`;
      }
      const progressBar = new ProgressBar(freeShippingThreshold, cartTotal);
    }

    _formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }

      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get("shipping-notice") == "undefined") {
    customElements.define("shipping-notice", ShippingNotice);
  }
}
